import { defineComponent } from "vue";
import { usePwaInstallPrompt } from "../../pwa/usePwaInstallPrompt.js";
import { useLocale } from "../../locales/i18n.js";


//////////////////////////////////////////////////
//  PWA INSTALL BUTTON
//////////////////////////////////////////////////


export default defineComponent({
    props: {
        buttonClass: {
            type    : String,
            default : "landing-button landing-button-install",
        },
    },

    setup(props) {
        const { i18n } = useLocale();
        const {
            canInstall,
            install,
        } = usePwaInstallPrompt();

        return () => canInstall.value
            ? (
                <button class={props.buttonClass} type="button" onClick={install}>
                    <i class="material-symbols-outlined">install_desktop</i>
                    {i18n("public.cta.install")}
                </button>
            )
            : null;
    },
});
